import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LanguageService } from 'language';
import { StateService } from 'utils';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../interfaces/rfe.response.interface';

@Injectable({
  providedIn: 'root',
})
export class RfeCallService {
  private http = inject(HttpClient);
  private state = inject(StateService);
  private languageService = inject(LanguageService);

  async newsletterSubmission(email: string, source: string) {
    const params = { email, brand: environment.brand, source, language: this.languageService.current };

    return this.http
      .post<ApiResponse<Record<string, unknown>>>(`${environment.oldEshopLink}/yalloeshop/subscribe_to_email`, params)
      .toPromise();
  }
}
